import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs/internal/Observable';
import {NeoSuspensionELminarDTO, NeoSuspensionServicioDTO} from '../../../Model/neoSuspensionServicioDTO';
import {AdministracionFechasYRangosService} from '../../../Service/administracion-fechas-y.rangos.service';
import { AlertService } from '../../../../services/alert.service';
import { UserService } from '../../../../services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';

@Component({
    selector: 'app-administracion-fecha-y-hora',
    templateUrl: './administracion-fecha-y-hora.component.html',
    styleUrls: ['./administracion-fecha-y-hora.component.scss'],
    standalone: false
})
export class AdministracionFechaYHoraComponent implements OnInit {
  horariosSuspension: Observable<NeoSuspensionServicioDTO[]>;
  idNeoCliente: any = 0;

  constructor(
    protected fechasYRangosService: AdministracionFechasYRangosService,
    protected userIntermediarioService: UserService,
    private alertService:AlertService,
    private _sweetAlert:SweetAlertService
  ) { }

  ngOnInit(): void {
    this.cargarIdNeoCliente();
    this.listaHorariosPorIDCliente();
  }

  cargarIdNeoCliente() {
    this.idNeoCliente = this.userIntermediarioService.getUser().idCliente;
  }

  listaHorariosPorIDCliente() {
    this.horariosSuspension =
      this.fechasYRangosService.listaDeHorariosPorIdCliente(
        this.idNeoCliente
      );
  }

  eliminarHorario(idSuspension: number, just: string) {
    const datosHorario: NeoSuspensionELminarDTO = {
      idSuspensionServicio: idSuspension,
      justificacion: just,
      idUsuario: Number(this.userIntermediarioService.getUser().idUsuario),
      idCliente: Number(this.idNeoCliente)
    };
    this.fechasYRangosService
      .eliminarHorario(datosHorario)
      .subscribe((response) => {
        this._sweetAlert.successModal("Éxito!",false,'Se ha eliminado el horario de suspensión');
        this.listaHorariosPorIDCliente();
      });
  }
}
